import gql from 'graphql-tag';

export const ZERO_UNCOUNTED_STOCKTAKE_ITEMS = gql`
	mutation zeroUncountedStocktakeItems ($id: ID!) {
		zeroUncountedStocktakeItems (id: $id) {
			id
			status
			percentageDifference
			valueOfDifference
			valueNotAccurate
			items {
				id
				quantity
				countedExpiryBatches
			}
		}
	}
`;
